<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-02 17:33:33
-->
<template>
  <div>
    <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">公司概况</div>
      </div>
    </div> -->
    <div class="main">
      <div class="nav">
        <div class="title">{{leftNavName}}</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue)"
          :key="index"
          >{{ item.dictName }}</a
        >
      </div>

      <div class="content">
        <div :class="{ imgstyle: tid == 5 }" v-html="info.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tid: "",
      navlist: [],
      info: {},
      leftNavName:''
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        // 二级菜单时，获取companySummaryType
        var nav = JSON.parse(localStorage.getItem("nav"));
        this.leftNavName = nav.filter(item => {
          return item.parent.code === "companySummaryType";
        })[0].parent.name;
        var navlist = nav.filter(item => {
          return item.parent.code === "companySummaryType";
        })[0].child;
        this.navlist = navlist;

        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    getinfo() {
      this.$post("/website/getCompanySummary", {
        menuCode: "companySummaryType",
        type: this.tid
      }).then(res => {
        this.info = res.data;
      });
    },
    changetab(index) {
      this.$router.push({ path: "/about/about", query: { tid: index } });
    }
  }
};
</script>
<style scoped>
/* .imgstyle /deep/ img {
  margin: 0 15px;
  margin-bottom: 20px;
  vertical-align: text-top;
} */

#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}

.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
</style>
